module.exports = __webpack_public_path__ + "img/20200810-1.2bf92fe7.png";